import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { useMediaQueries } from 'src/common/providers/MediaQueryProvider';
import { PATHS } from '../../constants';
import NavItemDropdown from './NavItemDropdown';

type ChargeNavItemProps = {
  classNameModifier?: string;
};

const ChargeNavItem: FC<ChargeNavItemProps> = ({ classNameModifier }) => {
  const [t] = useTranslation('navbar');
  const { m: isMediumAndUpScreenSize } = useMediaQueries();

  return (
    <NavItemDropdown
      classNameModifier={classNameModifier}
      icon="credit-card-charge"
      options={[
        {
          dropdownLabel: t('direct-booking'),
          icon: isMediumAndUpScreenSize ? undefined : 'credit-card-arrow',
          id: PATHS.CREATE_DIRECT_BOOKING,
        },
        {
          dropdownLabel: t('add-on-payment'),
          icon: isMediumAndUpScreenSize ? undefined : 'credit-card-check',
          id: PATHS.CHARGE_ADD_ON,
        },
      ]}
    >
      {t('charge')}
    </NavItemDropdown>
  );
};

export default ChargeNavItem;
